import { Resource as r, API as a } from "@coveo/platform-client";
const e = class e extends r {
  /**
   * Create a new IPX interface.
   * @param ipxInterfaceConfig The IPX interface configuration.
   * @param createPipelines Whether to create the pipelines or not.
   * @returns The created IPX interface configuration.
   */
  create(t, s = !1) {
    return this.api.post(
      `${e.baseUrl}/interfaces?createPipelines=${s}`,
      t
    );
  }
  /**
   * List all hosted IPX interfaces.
   * @param options The list options.
   * @returns The list of hosted IPX interfaces.
   */
  list(t) {
    return this.api.get(
      this.buildPath(`${e.baseUrl}/interfaces`, t)
    );
  }
  /**
   * Duplicate a hosted IPX interface.
   * @param duplicateParams The required params to duplicate an IPX.
   * @returns The duplicated IPX interface configuration.
   */
  duplicate(t, s) {
    return this.api.post(`${e.baseUrl}/interfaces/${s}`, t);
  }
  /**
   * Returns a paginated list of in-product experience interfaces for the specified project.
   *
   * @param {string | undefined} projectId ID of the project for which to retrieve in-product experience interfaces.
   * @param {ListHostedInterfacesParams} options Options to configure the request.
   * @returns {Promise<PageModel<IPXInterfaceConfiguration>>} Paginated list of in-product experience interfaces for the specified project.
   */
  listIpxInterfacesByProjectId(t, s = {}) {
    return this.api.get(
      this.buildPath(`${e.baseUrl}/projects/interfaces`, { ...s, projectId: t })
    );
  }
};
e.baseUrl = `/rest/organizations/${a.orgPlaceholder}/ipxinterface/v1`;
let i = e;
export {
  i as IPXInterfaceExperimentalResource
};
//# sourceMappingURL=IPXInterfaceResource.js.map
